import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Router } from "@angular/router";
import IRoles from "@models/roles.interface";
import { ErrorService } from "@services/error.service";
import { SessionService } from "@services/session.service";
import { TerminologiaService } from "@services/terminologia.service";
import Roles from "@shared/enums/roles.enum";

@Component({
	selector: "app-cambio-perfil",
	templateUrl: "./cambio-perfil.component.html",
	styleUrls: ["./cambio-perfil.component.scss"],
})
export class CambioPerfilComponent {
    @Input() inicio: boolean = false;

	constructor(
		private sessionService: SessionService,
		private errorService: ErrorService,
		private router: Router,
    private terminologiaService: TerminologiaService
	) {
		this.sessionService.rolSeleccionado$.subscribe((rol) => {
			// Cuando cambie el rol, vuelve a evaluar el sidebar
			if (rol) this.rolSeleccionado = rol;
		});
  }

	rolSeleccionado: Roles | ""; // Variable que maneja el rol seleccionado en el select
	isLoading: boolean = false; // Variable que maneja el renderizado del spinner de carga

	ngOnInit(): void {
		this.rolSeleccionado = this.sessionService.rolActual;
	}

	// el usuario esta logueado
	get isAuthenticated(): boolean {
		return this.sessionService.isAuthenticated();
	}

	// Opciones del select para elegir perfil
	get opcionesRoles(): IRoles[] {
		return this.sessionService.getRoles().map(r => this.terminologiaService.obtenerRolPorID(r));
	}

    get isMultiRol(): boolean {
        return this.sessionService.isMultiRol();
    }

    get nombreRolSeleccionado(): string {
        const rol = this.opcionesRoles.find(r => r.codigo === this.rolSeleccionado);
        return rol ? rol.nombre : '';
    }

	async cambiarRol() {
		this.isLoading = true;
		this.sessionService.isLoadingChangeRole = true;
		try {
			const rol = this.rolSeleccionado === "" ? null : this.rolSeleccionado;
			await this.sessionService.obtenerFuncionalidadesRol(rol);
			this.router.navigate(["inicio"]);
		} catch (error) {
			this.rolSeleccionado = this.sessionService.getSesionActual().rolSeleccionado;
			this.errorService.handle(error, "Error al seleccionar el perfil");
		} finally {
			this.isLoading = false;
			this.sessionService.isLoadingChangeRole = false;
		}
	}
}
